import httpService from "./httpService";
import utils from "./utils";

export default {
  findAll(example, pageable) {
    var params = utils.merge(example, pageable);
    return httpService.get("/vbBookDocType", {params: params});
  },
  count(example) {
    return httpService.get("/vbBookDocType/count", {params: example});
  },
  add(form) {
    return httpService.post("/vbBookDocType", form);
  },
  update(id, form) {
    return httpService.put(`/vbBookDocType/${id}`, form);
  },
  delete(id) {
    return httpService.delete(`/vbBookDocType/${id}`)
  },
  activeOrDeactive(id) {
    return httpService.get(`/vbBookDocType/activeOrDeactive/${id}`)
  },
  findById(id, config) {
    return httpService.get(`/vbBookDocType/${id}`, config)
  },
  findAllByBookIdAndDocTypeId(bookId, docTypeId) {
    return httpService.get("/vbBookDocType/findAllByBookIdAndDocTypeId", {params: {bookId: bookId, docTypeId: docTypeId}});
  }
};



// WEBPACK FOOTER //
// ./src/services/bookDocTypeService.js